/*
 * @Author: wangshengqiang
 * @Date: 2022-03-01 15:46:34
 * @LastEditTime: 2022-03-16 16:33:15
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useEffect } from 'react';
import Gs from '@/Gs';

const handle = e => {
  const {
    data
  } = e;
  return Gs.IMessageEventMap[data.type] && Gs.IMessageEventMap[data.type](data);
};

const IMessage = () => {
  useEffect(() => {
    Gs.IM.on('message', handle);
    return () => {
      Gs.IM.off('message', handle);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export default IMessage;